import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';    // haalt user en companyId uit je AuthContext
import api from './axios';                  // je axios-instance met credentials/interceptors

// Context voor CP-User permissions
const EP_UserPermissionsContext = createContext([]);

/**
 * Provider component dat permissions ophaalt en via context beschikbaar stelt
 */
export const EP_UserPermissionsProvider = ({ children }) => {
  const { user, companyId } = useAuth();
  const [userPermission, setUserPermission] = useState([]);

  useEffect(() => {
    // Wacht tot zowel user.email als companyId bekend zijn
    if (!user?.email || !companyId) return;

    // Vraag permissions op via je axios-instance
    api.post('/api/get_ep_user_permission', {
      companyId,
      email: user.email
    })
      .then(response => {
        const data = response.data;

        // rawPerm kan op twee plekken zitten, net als voorheen
        let rawPerm = '';
        if (Array.isArray(data.users) && data.users.length > 0) {
          rawPerm = data.users[0].json_permission;
        } else {
          rawPerm = data.json_permission;
        }

        // Probeer te parsen naar een array
        try {
          let parsed = JSON.parse(rawPerm || '[]');
          // Sommige responses bevatten een stringified JSON in een string
          if (typeof parsed === 'string') {
            parsed = JSON.parse(parsed);
          }
          setUserPermission(Array.isArray(parsed) ? parsed : []);
        } catch (err) {
          console.error('Error parsing user permissions:', err);
          setUserPermission([]);
        }
      })
      .catch(err => {
        console.error('Error fetching user permissions:', err);
        setUserPermission([]);
      });
  }, [user?.email, companyId]);

  return (
    <EP_UserPermissionsContext.Provider value={userPermission}>
      {children}
    </EP_UserPermissionsContext.Provider>
  );
};

/**
 * Custom hook om gemakkelijk permissions uit de context te halen
 */
export const EP_useUserPermissions = () => {
  return useContext(EP_UserPermissionsContext);
};
